// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import KeyOutlinedSvg from "@ant-design/icons-svg/es/asn/KeyOutlined";
import AntdIcon from '../components/AntdIcon';

var KeyOutlined = function KeyOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: KeyOutlinedSvg
  }));
};

KeyOutlined.displayName = 'KeyOutlined';
export default React.forwardRef(KeyOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/KeyOutlined.js
// module id = 1385
// module chunks = 0